module.exports = __webpack_public_path__ + "static/media/DV360.0e859eab.png";